var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCrunchbase = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeWidth: 1.224,
    d: "M13 25c6.627 0 12-5.373 12-12S19.627 1 13 1 1 6.373 1 13s5.373 12 12 12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    fillRule: "evenodd",
    d: "M10.186 15.875a1.873 1.873 0 1 1 1.049-2.532h1.474a3.276 3.276 0 1 0 0 1.554h-1.474a1.87 1.87 0 0 1-1.049.978m7.699 1.26a3.258 3.258 0 0 0-1.18-6.295h-.24a3.3 3.3 0 0 0-1.599.559V7.75h-1.332v9.385h1.341v-.338a3.27 3.27 0 0 0 3.01.337m.613-2.288a1.87 1.87 0 1 0-3.477-1.374 1.87 1.87 0 0 0 3.477 1.374",
    clipRule: "evenodd"
  })));
};
export default SvgCrunchbase;